import axios from "axios";

const search = {
  state: {
    transactionCodes: [],
    routes: [],
  },
  mutations: {
    SET_TRANSACTION_CODES(state, transactionCodes) {
      state.transactionCodes = transactionCodes;
    },
    SET_ROUTES(state, routes) {
        state.routes = routes;
      },
  },
  actions: {
    async fetchTransactionCodes({ commit }) {
        try {
          const response = await axios.get(`${process.env.VUE_APP_BASE_URL}module-route/transactionId`);
          commit("SET_TRANSACTION_CODES", response.data);
          return response.data;
        } catch (error) {
          console.error("Error fetching transaction codes:", error);
        }
      },
      async fetchRoutes({ commit }) {
        try {
          const response = await axios.get(`${process.env.VUE_APP_BASE_URL}search/get-all-routes`);
          commit("SET_ROUTES", response.data);
          return response.data;
        } catch (error) {
          console.error("Error fetching routes:", error);
          throw error;
        }
      },
  },
  getters: {
    transactionCodes: (state) => state.transactionCodes,
    routes: (state) => state.routes,
  },
};

export default search;
